import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';
// import * as _ from 'lodash';

import * as Search from '@app/models/search';
import { LibrarySearchService, LibraryService } from '@app/services/app/library.service';
import { AppService } from '@app/services/app/app.service';
import { AppRouterService } from '@app/services/app/router.service';
import { VersionsService } from '@app/services/app/versions.service';
import { AddProjectService } from '@app/services/app/add-project.service';

import { Session } from '@app/store/models/session.model';

import * as Objects from '@core/objects';
import { VersionShareItem } from '@core/models/version-share.model';
import { VersionListItemMenuClick } from '@core/components/versions/list/version-list-item-menu-click';
import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';
import { NotificationsContextEnum } from '@core/store/models/notifications.enum';

import { NotificationsService } from '@core/services/notifications/notifications.service';

@Component({
    selector: 'library-results',
    templateUrl: './results.component.html',
    styleUrls: ['./results.component.scss']
})
export class LibraryResultsComponent implements OnInit, OnDestroy {

    public readonly ACCESS_ADD_PROJECT = "access_global_new_request";
    public readonly PLUGIN_REQUEST_FEEDBACK = 'share_feedback';

    public readonly SEARCH_STATUS = Search.SearchHttpStatus;

    @Input() params: Search.SearchQueryParams = null;
    
    public addProjectAccess: boolean = false;
    public feedbacksAccess: boolean = false;
    public term: string = '';
    public loadingMore: boolean = false;
    // public searching: boolean = false;
    public loading: boolean = true;
    public loadingFeedbacks: boolean = false;
    public hasSearch: boolean = false;
    public resultsStatus: number = Search.SearchHttpStatus.INITIAL;
    public excludedLabels: Objects.Entity[] = [];
    public nextVersions: Objects.Version[] = [];

    public menu: Array<ThreeDotsMenuItem> = [
        {
            title: "Download All Files",
            key: "download-all",
            icon: "download",
            order: 1
        },
        {
            title: "See Artwork Details",
            key: "details",
            icon: "see-details",
            order: 2
        },
        {
            title: "See Original Project",
            key: "see-project",
            icon: "see-project",
            order: 3
        },
        {
            title: "See Older Artworks",
            key: "see-older",
            icon: "see-older",
            order: 5
        }
    ];

    // optional menu item
    protected menuAddProject: ThreeDotsMenuItem = {
        title: "Start New Project",
        key: "add-project",
        icon: "add",
        order: 4
    };

    protected resultsSubscriptor: Subscription;
    protected termSubscription: Subscription;
    protected appliedFiltersSubscription: Subscription;
    protected resultsStatusSubscriptor: Subscription;


    protected resultsFeedbacksSubscriptor: Subscription;
    // protected resultsFeedbacksStatusSubscriptor: Subscription; // not needed now, we need particular load check for each version
    protected nextVersionsSubscriptor: Subscription;

    public items: Array<Objects.Version> = null;
    public feedbacks: Array<VersionShareItem> = null;

	constructor(
        private app: AppService,
        private appRouter: AppRouterService,
        private librarySrv: LibraryService,
        private versionsSrv: VersionsService,
        private addProjectSrv: AddProjectService,
        private notifSrv: NotificationsService,
        private searchSrv: LibrarySearchService
    ){}

	ngOnInit(){
        this.resultsSubscriptor = this.librarySrv.selectResults().subscribe((versions: Objects.Version[]) => {
            this.loadingMore = false; // for stop loading more 
            this.items = versions; 
        });

        this.resultsStatusSubscriptor = this.librarySrv.selectResultStatus().subscribe((rStatus: number) => {
            this.resultsStatus = rStatus;
        });
        // Fix for the HAS search we need to take into account the params allways to show the proper message
        this.appliedFiltersSubscription = this.searchSrv.selectFilters().subscribe((filters: Search.SearchAppliedFilter[]) => {
            this.hasSearch = (filters.length >0 || this.params != null)
            this.excludedLabels = filters.filter((item) => item.key == 'label').map((f)=> f.item);
            // console.log(" excluded areeee ",this.excludedLabels);
        });

        this.termSubscription = this.searchSrv.selectTerm().subscribe((term: string) => {
            this.hasSearch = (term !='' || this.params != null)
        } );

        // get q, global access and plugins access
        this.app.getSession().subscribe( (session: Session) => {
            this.feedbacksAccess = session.options.plugins.some((pa: string) => pa == this.PLUGIN_REQUEST_FEEDBACK);
            this.addProjectAccess = session.options.access.hasOwnProperty(this.ACCESS_ADD_PROJECT)? session.options.access[this.ACCESS_ADD_PROJECT] : false;
            if(this.addProjectAccess){
                this.addToMenu(this.menuAddProject);
            }
            // let savedParams = null;
            // console.log("params in results--->", this.params, session.options.custom.library_search);
            if(this.params==null) 
                this.params = session.options.custom.library_search!=null? session.options.custom.library_search : this.params;

            // init library only when status is INITIAL -> is it will be DONE or FINAL each time we go back to library
            if(this.resultsStatus == this.SEARCH_STATUS.INITIAL){
                this.librarySrv.init(this.params, this.feedbacksAccess);
            }
            // session data already laoded.
            this.loading = false;
            this.init();
        });

        
	}

    ngOnDestroy() {
        this.resultsSubscriptor.unsubscribe();
        this.termSubscription.unsubscribe();
        this.appliedFiltersSubscription.unsubscribe();

        if (this.resultsFeedbacksSubscriptor)
            this.resultsFeedbacksSubscriptor.unsubscribe();
        // if (this.resultsFeedbacksStatusSubscriptor)
        //     this.resultsFeedbacksStatusSubscriptor.unsubscribe();
        if(this.nextVersionsSubscriptor)
            this.nextVersionsSubscriptor.unsubscribe();
    }

    // needed to init the feedbacks subscribers properly according access.
    init() {
        if(this.feedbacksAccess){
            this.initVersionFeedbackSubscribers();
        }
    }

    loadMore() {
        this.loadingMore = true;
        this.librarySrv.loadResults();
    }

    onMenuClick(menu: VersionListItemMenuClick) {
        switch(menu.key) {
            case "download-all":
                // start notification to download compressed version files in zip
                this.notifSrv.addNotification(NotificationsContextEnum.EVENT_FILES_COMPRESSION_START, {id: menu.version.id, details: { url: "/versions/"+menu.version.id}});
                break;
            case "details":
                // go to version Details
                if(menu.version != null)
                    this.appRouter.navigate("/versions/"+menu.version.id);
                break;
            case "see-project":
                // navigate
                if(menu.version != null){
                    this.versionsSrv.getProject$(menu.version).subscribe((originalProject: Objects.Request) => {
                        if(originalProject != null)
                            this.appRouter.navigate('/projects/'+originalProject.id);
                    });
                }
                break;
            case "add-project":
                if(menu.version != null){
                    this.addProjectSrv.clear();
                    this.appRouter.navigate('/projects/add', { queryParams: { version: menu.version.id } });
                }
                break;
            case "see-older":
                if(menu.version != null){
                    this.appRouter.navigate('/versions/'+menu.version.id+"/related");
                }
                break;
        }
    }

    onFileClick(version: Objects.Version,file: Objects.File){
        if (file != null && version != null){
            // set this url to preview version FILE
            this.appRouter.navigate("/versions/"+version.id + "/files/"+file.id);
        }
    }

    onLabelClick(tag: Objects.Label):void{
        if (tag != null ){
            // send this tag to the filters here!!!
            this.searchSrv.applyFilter({key:"label",item: tag});
            
        }
    }

    onScroll(){
        if(this.resultsStatus ==  Search.SearchHttpStatus.DONE ){
            this.loadMore();
        }
    }

    protected addToMenu(item: ThreeDotsMenuItem) {
        this.menu = this.menu.filter((i: ThreeDotsMenuItem) => item.key != i.key);
        this.menu.push(item);
    }

    protected initVersionFeedbackSubscribers(){
        this.resultsFeedbacksSubscriptor = this.librarySrv.selectVersionFeedbacks().subscribe((feedbacks: VersionShareItem[]) => {
            this.feedbacks = [...feedbacks];
        });
        // not general status used now
        // this.resultsFeedbacksStatusSubscriptor = this.librarySrv.selectVersionFeedbacksStatus().subscribe((loading: number) => {
        //     this.loadingFeedbacks = (loading != Search.SearchHttpStatus.DONE && loading != Search.SearchHttpStatus.FINAL ) ? true : false;
        // });
        this.nextVersionsSubscriptor = this.librarySrv.selectCurrentVersionsLoading().subscribe((currentVersions: Objects.Version[]) => {
            this.nextVersions = currentVersions;
        });

    }

    public getFeedbacks(version: Objects.Version) : VersionShareItem[] {
        // Check when there are some new versions or feedbacks loading
        if (!this.feedbacksAccess){
            return [];
        }
        // check if version is currently loaded. when feedbacks call for nextversions are successed, next will be empty
        if(this.feedbacks == null || (this.nextVersions.length > 0 && this.nextVersions.some((v) => v.id == version.id)))
            return null;

        let vFeedback = this.feedbacks.filter((f: VersionShareItem) => f.version.id == version.id)
        return vFeedback;
    }

    public updateVersionStatus(status, version){
        this.librarySrv.setVersionStatus(version.id,status)
    }

}
